import createStore from "astrid-helpers/src/createStore";
export const [getPosition, setPosition, usePosition, onPosition] = createStore(0);
//# sourceMappingURL=position.js.map